import type { SchoolHeaderV1Attributes } from '@/features/school-header-v1/school-header-v1-type';

import DividerHorizontalDesktop from '@/core/components/divider/divider-horizontal-desktop';
import { Badges } from '@/core/features';
import IconImage from '@/core/features/image-v2/icon-image';
import HeaderMapButtonDesktop from '@/features/map/header-map-button-desktop/header-map-button-desktop';

import styles from './school-header-v1-desktop.module.scss';

export default function SchoolHeaderV1Desktop({
    badges,
    headline,
    logo,
    mapButton,
    subHeadline,
}: SchoolHeaderV1Attributes) {
    return (
        <>
            <div className={styles.contentWrapper}>
                <div className={styles.headLineWrapper}>
                    <div className={'line-clamp-2 font-size-24 bold'}>{headline}</div>
                    <div className={'width-100 flex'}>
                        <div className={'line-clamp-2 font-size-24'}>{subHeadline}</div>
                        {badges && (
                            <div className={styles.badge}>
                                <Badges
                                    badges={badges}
                                    fontSize={14}
                                />
                            </div>
                        )}
                    </div>
                </div>
                <div className={'flex-center gap-40'}>
                    {mapButton && (
                        <HeaderMapButtonDesktop
                            iconUrl={mapButton.iconUrl}
                            linkUrl={mapButton.linkUrl}
                            title={mapButton.text}
                            width={'120px'}
                        />
                    )}
                    {logo && (
                        <div className={'flex-center'}>
                            <IconImage
                                alt={logo.imageAlt}
                                height={55}
                                url={logo.imageUrl}
                                width={55}
                            />
                        </div>
                    )}
                </div>
            </div>
            <DividerHorizontalDesktop
                color={'alto'}
                marginBottom={0}
                marginTop={20}
            />
        </>
    );
}
